import { h } from "@stencil/core";

export const ErrorNumberInput = ({ t, prefillData }) => {
    return (
        <div class="ux-u-margin-bottom-20">
            <label class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">{t("field.errorNumber.label")}</label>
            <service-calls-dynamic-input
                add-text={t("field.errorNumber.addAnotherNumber")}
                input-name="errorNumber1"
                prefilledValues={prefillData?.productData.errorNumbers || []}
                init-items={prefillData?.productData.errorNumbers?.length || 1}
                min-items="1"
                max-items="6"
                disabled={!!prefillData?.productData.errorNumbers}
            >
                <div class="mf-create-service-case__help-block" slot="info">
                    <p class="ux-text-tiny">
                        {t("field.errorNumber.explanation", {
                            example1: "0000FC00",
                            example2: "1.10.58102409",
                            example3: "6000"
                        })}
                    </p>
                </div>
            </service-calls-dynamic-input>
        </div>
    );
};
